module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Jc.c54bfd67.png";